<template>
  <div class="map-setting">
    <div class="map-setting-title">
      <span>地图设置</span>
    </div>
    <div class="map-setting-context">
      <el-form ref="ruleFormRef" style="max-width: 600px" :model="config" status-icon label-width="170px">
        <el-form-item label="第一次间隔天数" prop="config['sys.login.intervalOne']">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-input-number v-model="config['sys.login.intervalOne'].value" class="mx-4" controls-position="right" />
            </el-col>
            <el-col :span="12">
              <el-select v-model="config['sys.login.intervalOneColor'].color" placeholder="Select" style="width: 240px"
                @change="updateColorValue('sys.login.intervalOneColor')">
                <template #prefix>
                  <el-tag :color="config['sys.login.intervalOneColor'].color" style="margin-right: 8px" size="small" />
                </template>
                <el-option v-for="item in colors" :key="item.value" :label="item.label" :value="item.value">
                  <div class="flex items-center">
                    <el-tag :color="item.value" style="margin-right: 8px" size="small" />
                    <span :style="{ color: item.value }">{{ item.label }}</span>
                  </div>
                </el-option>

                <template #tag>
                  <el-tag v-for="color in value" :key="color" :color="color" />
                </template>
              </el-select>

            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="第二次间隔天数" prop="config['sys.login.intervalTwo']">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-input-number v-model="config['sys.login.intervalTwo'].value" class="mx-4" controls-position="right" />
            </el-col>
            <el-col :span="12">
              <el-select v-model="config['sys.login.intervalTwpColor'].color" placeholder="Select" style="width: 240px"
                @change="updateColorValue('sys.login.intervalTwpColor')">
                <template #prefix>
                  <el-tag :color="config['sys.login.intervalTwpColor'].color" style="margin-right: 8px" size="small" />
                </template>
                <el-option v-for="item in colors" :key="item.value" :label="item.label" :value="item.value">
                  <div class="flex items-center">
                    <el-tag :color="item.value" style="margin-right: 8px" size="small" />
                    <span :style="{ color: item.value }">{{ item.label }}</span>
                  </div>
                </el-option>

                <template #tag>
                  <el-tag v-for="color in value" :key="color" :color="color" />
                </template>
              </el-select>

            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="大于第二次间隔天数" prop="config['sys.login.intervalTwo']">
          <el-row :gutter="20">
            <el-col :span="10">
            
              <el-input-number style="visibility: hidden;" :min="1" :max="10" controls-position="right" />
            </el-col>
            <el-col :span="12">
              <el-select v-model="config['sys.login.intervalThereColor'].color" placeholder="Select"
                style="width: 240px" @change="updateColorValue('sys.login.intervalThereColor')">
                <template #prefix>
                  <el-tag :color="config['sys.login.intervalThereColor'].color" style="margin-right: 8px"
                    size="small" />
                </template>
                <el-option v-for="item in colors" :key="item.value" :label="item.label" :value="item.value">
                  <div class="flex items-center">
                    <el-tag :color="item.value" style="margin-right: 8px" size="small" />
                    <span :style="{ color: item.value }">{{ item.label }}</span>
                  </div>
                </el-option>

                <template #tag>
                  <el-tag v-for="color in value" :key="color" :color="color" />
                </template>
              </el-select>

            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button  class="submit-button-center" type="primary" @click="submitForm(ruleFormRef)">
            提交
          </el-button>

        </el-form-item>

      </el-form>
    </div>
  </div>
</template>

<script>
import { getConfigList, updateConfig } from '@/api/Common';
import { useMapStore } from '@/stores/mapStore';
import _ from 'lodash'; // 引入 lodash 用于深比较

export default {
  name: "MapSetting",
  components: {},
  data() {
    return {
      mapStore: null,
      config: {
        "sys.login.intervalOne": { value: 1, configName: "用户登录-第一次间隔天数", configId: 0 }, // 第一次间隔天数
        "sys.login.intervalTwo": { value: 2, configName: "用户登录-第二次间隔天数", configId: 0 }, // 第二次间隔天数
        "sys.login.intervalOneColor": { color: "#00ffff", value: 0, configName: "用户登录-低于第一次间隔天数颜色", configId: 0 }, // 第一次间隔天数颜色
        "sys.login.intervalTwpColor": { color: "#00ffff", value: 0, configName: "用户登录-低于第二次间隔天数颜色", configId: 0 }, // 第二次间隔天数颜色
        "sys.login.intervalThereColor": { color: "#00ffff", value: 0, configName: "用户登录-低于第三次间隔天数颜色", configId: 0 }, // 大于第二次间隔天数颜色
      },
      initialForm: {}, // 存储初始表单数据
      colors: [],
    };
  },
  mounted() {
    this.mapStore = useMapStore();
    this.colors = this.mapStore.colors;
    this.getConfigList();
  },
  methods: {
    getConfigList() {
      let that = this;
      getConfigList().then(res => {
        if (res.code == 200) {
          res.rows.forEach(item => {
            if (that.config[item.configKey]) {
              that.config[item.configKey].value = parseInt(item.configValue);
              that.config[item.configKey].configId = item.configId;


              if (that.config[item.configKey].color) {
                that.config[item.configKey].color = that.colors[item.configValue].value;
              }
            }
          });

          this.initialForm = _.cloneDeep(this.config);
        }
      })
    },
    // 新增方法，用于同步更新 color 和 value
    updateColorValue(configKey) {
      const selectedColor = this.config[configKey].color;
      const selectedItem = this.colors.find(item => item.value === selectedColor);
      if (selectedItem) {
        this.config[configKey].value = selectedItem.index;
      }
    },
    submitForm(formName) {
      let that = this;

      const changedItems = [];
      for (let key in this.config) {
        const oldValue = this.initialForm[key];
        const newValue = this.config[key];
        if (oldValue.value != newValue.value) {
          changedItems.push({
            configId: newValue.configId,
            configKey: key,
            configValue: newValue.value,
            configName: newValue.configName,
          });
        }
      }
      console.log(changedItems)
      if (changedItems.length === 0) {
        alert("修改成功");
        return;
      }

      // 逐个提交变化的项
      const promises = changedItems.map(item => {
        return updateConfig(item).then(res => {
          if (res.code === 200) {
            console.log(`${item.configKey} 提交成功`);
          } else {
            console.error(`${item.configKey} 提交失败`, res);
          }
          return res;
        }).catch(error => {
          console.error(`${item.configKey} 提交出错`, error);
          throw error;
        });
      });

      // 等待所有请求完成
      Promise.all(promises).then(() => {
        // 更新初始数据
        this.initialForm = _.cloneDeep(this.config);
        alert("修改成功");
      }).catch(() => {
        console.error('部分提交失败');
      });
    }
  }
}
</script>

<style scoped>
.map-setting {
  height: 100%;
  width: 100%;
  background-color: #f8fbfe;

}

.map-setting-title {
  height: 40px !important;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  color: #428bca !important;
}

.map-setting-title span {
  font-size: 14px;
  line-height: 40px;
  padding-left: 15px;
}

.map-setting-context {
  margin-top: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;


}

.el-tag {
  border: none;
  aspect-ratio: 1;
}

/* ... 已有代码 ... */
.submit-button-center {
  display: block; /* 将按钮设置为块级元素 */
  
}
</style>
